import { Route, Routes, useNavigate } from 'react-router-dom';
import ProductNav from '../shared/ProductNav';
import OrderNav from '../shared/OrderNav';
import ShopNav from '../shared/ShopNav';
import UserNav from '../shared/UserNav';
import SectorNav from '../shared/SectorNav';
import CategoryNav from '../shared/CategoryNav';
import AdminLayout from '../../layouts/AdminLayout';
import SettingsNav from '../shared/SettingsNav';
import { useAuth } from '@cabukaka/hooks';
import AdminDashboardPage from '../../pages/admin/AdminDashboardPaga';

export default function AdminNav() {
    const navigate = useNavigate()
    const { logout, user } = useAuth()
    const goToProfile = () => {
        navigate("/admin/settings")
    }

    return (
        <AdminLayout
            onLogout={logout}
            onGotoProfile={goToProfile}
            companyName={user?.username || "Admin Cabukaka"}
            email={user?.email || 'admin.cabukaka.com'}
        >
            <Routes>
                <Route path="/products/*" element={<ProductNav />} />
                <Route path="/orders/*" element={<OrderNav />} />
                <Route path="/shops/*" element={<ShopNav />} />
                <Route path="/users/*" element={<UserNav />} />
                <Route path="/sectors/*" element={<SectorNav />} />
                <Route path="/categories/*" element={<CategoryNav />} />
                <Route path="/users/*" element={<UserNav />} />
                <Route path="/settings/*" element={<SettingsNav />} />
                <Route path="/overview" element={<AdminDashboardPage />} />

            </Routes>
        </AdminLayout>
    );
}